function PressLogos() {
    const logos = ["DEMO/logos/fundscene.png", "DEMO/logos/handelsblatt.png", "DEMO/logos/btcecho.png", "DEMO/logos/t3n.png"];

    return(
        <div className="my-20">
            <p className="text-slate-400 font-semibold">
                Known from
            </p>
            <div className="flex flex-row flex-wrap justify-center">
                {logos.map((logo, i) => (
                    <img src={logo} alt="logo" height="45px" className="m-6 object-contain" key={"pressLogo-" + i} />
                ))}
            </div>
        </div>
    )
}

export default PressLogos;